import { LoadableAfterPaint } from '@confluence/loadable';

export const RendererContentState = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-RendererContentStateRendererContentState" */ '../src/RendererContentState/RendererContentState'
			)
		).RendererContentState,
});
